export const storeData = (state: any) => state?.getSecData?.value;
export const activeAccordionData = (state: any) =>
  state?.activeAccordion?.value;
export const paymentTermDaysData = (state: any) =>
  state?.setPaymentTermDays?.value;
export const activeDefaultAccordianData = (state: any) =>
  state?.activeDefaultAccordian?.value;
export const defaultStoreData = (state: any) => state?.getDefaultData?.value;
